import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ObjectService {
  constructor() {}

  /**
   * Creates a shallow clone of the specified object
   * @param obj The object to clone.
   * @return A shallow clone of the object.
   */
  public cloneObject = (obj: any): any => {
    const newObject: any = {};

    Object.keys(obj).forEach(key => {
      newObject[key] = obj[key];
    });

    return newObject;
  };

  /**
   * Compares to objects or values for equality, using a shallow compare.
   * @param obj1 The first object
   * @param obj2 The second object
   * @param exclude Property names needs to be excluded from equality
   * @return true if the two values are equal, false otherwise
   */
  public equals = (obj1: any, obj2: any, exclude: string[] = []): boolean => {
    return this.areEqual(obj1, obj2, exclude) && this.areEqual(obj2, obj1, exclude);
  };

  /**
   * Compares two arrays of objects values for equality, using a shallow compare.
   * @param arr1 The first object array
   * @param arr2 The second object array
   * @param exclude Property names needs to be excluded from equality
   * @return true if the two values are equal, false otherwise
   */
  public arraysEqual = (arr1: any[], arr2: any[], exclude: string[] = []): boolean => {
    return arr1.length === arr2.length && arr1.every((o, idx) => this.equals(o, arr2[idx], exclude));
  };

  private areEqual = (obj1: any, obj2: any, exclude: string[] = []): boolean => {
    let result = true;

    try {
      for (const key in obj1) {
        if (exclude.indexOf(key) > -1) {
          continue;
        }

        if (Array.isArray(obj1[key]) && Array.isArray(obj2[key])) {
          if (!this.arraysEqual(obj1[key], obj2[key])) {
            result = false;
            break;
          }
        } else if (obj1[key] !== obj2[key] && (!!obj1[key] || !!obj2[key])) {
          result = false;
          break;
        }
      }
    } catch (error) {
      result = false;
    }

    return result;
  };
}
